import { render, staticRenderFns } from "./channelPrice.vue?vue&type=template&id=61d89b79&scoped=true"
import script from "./channelPrice.vue?vue&type=script&lang=js"
export * from "./channelPrice.vue?vue&type=script&lang=js"
import style0 from "./channelPrice.vue?vue&type=style&index=0&id=61d89b79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d89b79",
  null
  
)

export default component.exports